import React, { useState, useContext } from 'react';
import InfoToolTip from '../infoToolTip';
import { MainContext } from './contexts';

const TaskTemplateEditor = () => {
  const { data } = useContext(MainContext);
  const [ showTaskTemplate, setShowTaskTemplate ] = useState(data.show_task_template || false);

  const handleChangeShowTaskTemplate = (event) => {
    setShowTaskTemplate(!showTaskTemplate);
  };

  return (
    <div className="form_section">
      <div className="form_section-title -grid">
        <div className="form_section-title-item -grid">
          <div className="toggle">
            <input name="project[show_task_template]" type="hidden" value="0" autoComplete="off" />
            <input
              id="project_show_task_template"
              type="checkbox"
              name="project[show_task_template]"
              className="hide"
              checked={ showTaskTemplate }
              value="1"
              onChange={ handleChangeShowTaskTemplate }
            />
            <label className="form-switch" htmlFor="project_show_task_template">
              Show templated text
            </label>
          </div>
          <h3>Show templated text</h3>
        </div>
        <div className="form_section-title-item">
          <InfoToolTip
            remote
            text={
              <>
                Option to display the default templated text on a product description step
                { ' ' }
                started with: "Please read the following description..."
              </>
            }
            position="bottom-right"
          />
        </div>
      </div>
    </div>
  );
};

export default TaskTemplateEditor;
